import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
} from 'react-intl';

import {
  Button,
} from '@folio/stripes/components';

import WrapperForFormElementWithoutLabel from '../wrapper-for-form-element-without-label';

const RemoveUserAssignment = ({
  onClick,
}) => {
  return (
    <WrapperForFormElementWithoutLabel>
      <Button onClick={onClick}>
        <FormattedMessage id="ui-task-list.team.button.unassign" />
      </Button>
    </WrapperForFormElementWithoutLabel>
  );
};

RemoveUserAssignment.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RemoveUserAssignment;
